import {ConfigObjectType} from '@wallaby-ui/core';
import {useNavigationContext, useValuesToCopy} from '@wallaby-ui/document';
import {AppLayout} from '@wallaby-ui/layout';
import * as React from 'react';

import {AppLayoutContent} from './AppLayoutContent';
import navigationConfig from '../../../config/common/navigation_config';

interface OwnProps {
  config: ConfigObjectType;
}
type Props = OwnProps;

export const AppLayoutContainer: React.FC<Props> = (props) => {
  const {config} = props;
  const navigationContext = useNavigationContext(config, navigationConfig as any);
  const {valuesToCopy, setValuesToCopy} = useValuesToCopy();
  const isLoading = false;
  return isLoading ? null : (
    <AppLayout
      config={config}
      logoName={'HAIDI_Logo_White_RGB.svg'}
      logoSignName={'arrowLogoSign_white.svg'}
      navigationContext={navigationContext}
      valuesToCopy={valuesToCopy}
    >
      <AppLayoutContent
        config={config}
        navigationContext={navigationContext}
        valuesToCopy={valuesToCopy}
        setValuesToCopy={setValuesToCopy}
      />
    </AppLayout>
  );
};
